import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import { getLocaleKey } from "./utils/localizationHelper";

// Import web component loader early - following magellan-genomic-product-search-ui pattern
import "./webComponentLoader";

// Set HTML lang attribute based on locale
const localeKey = getLocaleKey();
const langMap = {
  default: "en",
  zh_cn: "zh",
};
document.documentElement.lang = langMap[localeKey] || "en";
console.log(`[App] Setting HTML lang attribute to: ${document.documentElement.lang} (locale: ${localeKey})`);

// Add cookie monitoring for debugging (helps identify when cookies change in QA)
if (typeof window !== "undefined") {
  let lastCookies = document.cookie;
  setInterval(() => {
    if (document.cookie !== lastCookies) {
      const getCookieValue = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        return parts.length === 2 ? parts.pop().split(";").shift() : null;
      };
      console.log('[App] 🍪 Cookie change detected!', {
        CK_ISO_CODE: getCookieValue('CK_ISO_CODE'),
        CK_LANG_CODE: getCookieValue('CK_LANG_CODE'),
        timestamp: new Date().toISOString()
      });
      lastCookies = document.cookie;
    }
  }, 500);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // Temporarily disable StrictMode to prevent double API calls in development
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
